// AssignmentsPage.js
import React, { useEffect, useState } from "react";
import "./AssignmentsPage.css"; // We'll style it cleanly here

const SHEET_URL =
  "https://opensheet.elk.sh/11R9T54CjmC2RFZuvmD7fxElItomKuvfTb9t5nHjeWNU/Assignments";

export default function AssignmentsPage() {
  const [assignments, setAssignments] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortAsc, setSortAsc] = useState(true);
  const [selected, setSelected] = useState(null);
  const rowsPerPage = 10;

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.json())
      .then((data) => {
        const today = new Date();
        const formatted = data.map((row) => {
          const dueDateStr = row["DueDate"] || row["Due Date"];
          const dueDate = new Date(dueDateStr);
          const daysLeft = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
          return {
            courseId: row["CourseId"] || "",
            courseName: row["CourseName"] || "",
            assignment: row["Assignment"] || "",
            description: row["Description"] || "",
            refMaterial: row["Reference-Material"] || "",
            platform: row["Platform"] || "",
            documentType: row["DocumentType"] || "",
            dueDateStr,
            dueDate,
            daysLeft,
          };
        });
        setAssignments(formatted);
        setFiltered(formatted);
      })
      .catch((err) => console.error("Error loading assignments", err));
  }, []);

  // 🔍 Search filter
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const results = assignments.filter(
      (a) =>
        a.assignment.toLowerCase().includes(term) ||
        a.courseName.toLowerCase().includes(term)
    );
    setFiltered(results);
    setCurrentPage(1);
  }, [searchTerm, assignments]);

  // 📅 Sorting toggle
  const handleSort = () => {
    const sorted = [...filtered].sort((a, b) =>
      sortAsc ? a.dueDate - b.dueDate : b.dueDate - a.dueDate
    );
    setFiltered(sorted);
    setSortAsc(!sortAsc);
  };

  // 📄 Pagination
  const start = (currentPage - 1) * rowsPerPage;
  const pageData = filtered.slice(start, start + rowsPerPage);
  const pageCount = Math.ceil(filtered.length / rowsPerPage);

  return (
    <div className="assignments-container">
      <h2 className="page-title">📚 Assignments</h2>

      <div className="search-container">
        <input
          className="search-input"
          type="text"
          placeholder="Search by Course or Assignment..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th onClick={handleSort}>Course Name ▲▼</th>
              <th>Assignment</th>
              <th>Due Date</th>
              <th>Days Left</th>
              <th>Reference Material</th>
              <th>Platform</th>
              <th>Document Type</th>
            </tr>
          </thead>
          <tbody>
            {pageData.map((a, i) => (
              <tr key={i}>
                <td>{a.courseName}</td>
                <td
                  className="assignment-link"
                  onClick={() => setSelected(a)}
                >
                  {a.assignment}
                </td>
                <td>{a.dueDateStr}</td>
                <td
                  className={`days-left ${
                    a.daysLeft <= 3 && a.daysLeft > 0 ? "upcoming" : ""
                  }`}
                  style={{
                    color:
                      a.daysLeft <= 0
                        ? "#b71c1c"
                        : a.daysLeft <= 3
                        ? "#ff9800"
                        : "#0b57d0",
                  }}
                >
                  {a.daysLeft > 0
                    ? `${a.daysLeft} day(s) left`
                    : "Overdue"}
                </td>
                <td>
                  {a.refMaterial ? (
                    <a href={a.refMaterial} target="_blank" rel="noreferrer">
                      Link
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
                <td>{a.platform || "-"}</td>
                <td>{a.documentType || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination">
        {Array.from({ length: pageCount }, (_, i) => (
          <button
            key={i}
            className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* Modal */}
      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => setSelected(null)}>
              &times;
            </span>
            <h3>{selected.assignment}</h3>
            <p className="modal-course">{selected.courseName}</p>
            <p>{selected.description}</p>
            <p>
              <strong>Due Date:</strong> {selected.dueDateStr} (
              {selected.daysLeft > 0
                ? `${selected.daysLeft} day(s) left`
                : "Overdue"}
              )
            </p>
            {selected.platform && (
              <p>
                <strong>Platform:</strong> {selected.platform}
              </p>
            )}
            {selected.documentType && (
              <p>
                <strong>Document Type:</strong> {selected.documentType}
              </p>
            )}
            {selected.refMaterial && (
              <p>
                <strong>Reference Material:</strong>{" "}
                <a
                  href={selected.refMaterial}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selected.refMaterial}
                </a>
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
